import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { EDialogAction } from "../Enum/DialogActionEnum";
import { useSnackbar } from "notistack";
import { Button, TextField } from "@mui/material";

const StaffDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const [staff, setStaff] = useState(props.data);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const formRef = useRef<any>();

  useEffect(() => {
    setStaff(props.data);
  }, [props.data]);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createStaff = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/staffs`;

      const res = await axiosInstance.post(url, {
        name: data.name,
        contact_no: data.contact_no,
        email: data.email,
        designation: data.designation,
      });
      enqueueSnackbar("Staff Created Successfully!!!!", {
        variant: "success",
      });
      handleClose("created");
    } catch (err: any) {
      enqueueSnackbar(
        `Staff Creation Unsuccessful!!!! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
      console.error(err);
    }
  };

  const editStaff = async (data: any) => {
    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/staffs/${staff.id}`;

    axiosInstance
      .put(url, {
        name: data.name,
        contact_no: data.contact_no,
        email: data.email,
        designation: data.designation,
      })
      .then((response) => {
        enqueueSnackbar("Staff Updated Successfully!!!!", {
          variant: "success",
        });
      })
      .catch((err: any) => {
        enqueueSnackbar(
          `Staff Updatation Unsuccessful!!!! ${err.response.data.error}`,
          {
            variant: "error",
          }
        );
      });

    handleClose();
  };

  return (
    <>
      {" "}
      {staff == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Staff :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Create Staff </DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.view ? (
            <DialogTitle>View Staff :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                      name: "",
                      contact_no: "",
                      email: "",
                      designation: "",
                    }
                  : staff
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                name: Yup.string()
                  .required("Name is Required")
                  .max(85, "Name must not be greater than 85 characters"),
                contact_no: Yup.string()
                  .max(
                    15,
                    "Contact Number must not be greater than 15 characters"
                  )
                  .required("Contact Number is Required"),
                email: Yup.string()
                  .email("Invalid email format")
                  .required("Email is Required"),
                designation: Yup.string()
                  .required("Designation is Required")
                  .max(50, "Designation must not be greater than 50 characters"),
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createStaff
                  : editStaff
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2 ">
                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="outlined-multiline-flexible"
                      label="Name"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.name || ""}
                      placeholder="Enter Name"
                      name="name"
                      required
                      error={Boolean(errors.name && touched.name)}
                      helperText={
                        errors.name && touched.name && String(errors.name)
                      }
                    />
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="contact_no"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.contact_no || ""}
                      placeholder="Enter Contact Number"
                      name="contact_no"
                      required
                      label="Contact Number"
                      error={Boolean(errors.contact_no && touched.contact_no)}
                      helperText={
                        errors.contact_no &&
                        touched.contact_no &&
                        String(errors.contact_no)
                      }
                    />
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="email"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.email || ""}
                      placeholder="Enter Email"
                      name="email"
                      required
                      label="Email"
                      error={Boolean(errors.email && touched.email)}
                      helperText={
                        errors.email && touched.email && String(errors.email)
                      }
                    />
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4 mt-2">
                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="designation"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.designation || ""}
                      placeholder="Enter Designation"
                      name="designation"
                      required
                      label="Designation"
                      error={Boolean(errors.designation && touched.designation)}
                      helperText={
                        errors.designation &&
                        touched.designation &&
                        String(errors.designation)
                      }
                    />
                  </div>
                  <div>
                    <div className="flex space-x-2">
                      {props.dialogAction != EDialogAction.view ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          {props.dialogAction == EDialogAction.edit ? "Update" : "Create"}
                        </Button>
                      ) : null}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default StaffDialogBox;
